import React, { useRef } from 'react';
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.
import logoSrc from '../img/logo.png'; // Assuming the logo is in the img folder


function TeamTrainingPage() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };


  return (
    <>
   
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title" id="titulli">skills that drive success</h1>
            <p className="banner-description">
              Empower your team through a structured development program to boost performance and cohesion.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>
          </div>
         
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Premium Services Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
      </div>
      <section className="about-section">
        {/* Section 1: What We Offer */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Structured Team Development</strong></h2>
            <p>
              Our 6-month program focuses on defining team purpose, setting clear goals, and creating high-performance teams.
            </p>
            <ul>
              <p><strong>Goal Setting:</strong> Establish clear objectives.</p>
              <p><strong>Team Synergy:</strong> Build complementary skill sets.</p>
              <p><strong>Performance Monitoring:</strong> Track progress and celebrate success.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ps5.1.png" alt="Team Development" />
          </div>
        </div>

        {/* Section 2: Benefits for Teams */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Empower Your Team</strong></h2>
            <p>
              Develop essential skills and teamwork to improve productivity and cohesiveness.
            </p>
            <ul>
              <p><strong>Skill Development:</strong> Enhance leadership and communication.</p>
              <p><strong>Increased Cohesion:</strong> Build stronger, more effective teams.</p>
              <p><strong>Flexible Training:</strong> Available worldwide, tailored for your team.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ps5.2.png" alt="Team Benefits" />
          </div>
        </div>

        {/* Section 3: Success Stories */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Our Impact on Teams</strong></h2>
            <p>
              Teams who have completed our program report increased collaboration, productivity, and performance.
            </p>
            <a href='/blog' className="cta-button">Read Our Success Stories</a>
          </div>
          <div className="about-image">
            <img src="/img/ps5.3.png" alt="Success Stories" />
          </div>
        </div>
      </section>
      
  <ContactForm ref={contactFormRef} />
    </>
  );
}

export default TeamTrainingPage;
